export const namespaced = true;

export const state = () => {
    return {
        search: '',
        results: [],
        meta: {
            last_page: 1,
            total: 1,
        },
        page: 1,
        per_page: 25,
        loading: false,
    }
}

export const mutations = {

    SET_SEARCH(state, search) {
        state.search = search;
    },

    FETCH_RESULTS(state, results) {
        state.results = results;
    },

    FETCH_META(state, meta) {
        state.meta = meta;
    },

    SET_PAGE(state, page) {
        state.page = page;
    },

    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },

    SET_LOADING(state, loading) {
        state.loading = loading;
    },
}

export const actions = {
    setSearch({ commit }, search) {
        commit('SET_SEARCH', search);
    },

    async fetch({ commit, state, dispatch }) {
        if (state.search.length >= 2) {
            try {
                const res = await axios.get(`/api/admin/search`, {
                    params: {
                        search: state.search,
                        page: state.page,
                        per_page: state.per_page
                    }
                });
                commit('FETCH_RESULTS', res.data.data);
                commit('FETCH_META', {
                    last_page: res.data.last_page,
                    total: res.data.total
                });
            } catch (error) {
                const notification = {
                    plot: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true })
            }
        }

    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
        dispatch('fetch');
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
        dispatch('fetch');
    },
}
